<template>
	<div class="app-sidebar" :class="{ collapsed }">
		<ul class="app-sidebar-nav">
			<slot></slot>
		</ul>

		<ul class="app-sidebar-nav app-sidebar-footer">
			<slot name="footer"></slot>
		</ul>
	</div>
</template>

<script>
export default {
	computed: {
		/**
		 * Returns the `appBarCollapsed` property from the store
		 *
		 * @returns {boolean}
		 */
		collapsed () {
			return this.$store.getters['ui/appBarCollapsed'];
		}
	}
};
</script>

<style lang="scss">
@import "../../_variables.scss";

.app-sidebar {
	position: fixed;
	top: $app-topbar-height;
	left: 0;
	bottom: 0;
	width: $app-sidebar-width;
	background-color: $app-sidebar-bg;
	z-index: 1000;

	&.collapsed {
		width: $app-sidebar-collapsed-width;
	}

	.app-sidebar-nav {
		position: absolute;
		top: 0;
		right: 0;
		left: 0;
		margin: 0;
		padding: 0;
		list-style-type: none;

		&.app-sidebar-footer {
			top: auto;
			bottom: 0;
		}
	}
}
</style>
